import { createActions, createReducer } from 'reduxsauce'

import DetalhesPrestacaoService from '../../servicos/DetalhesPrestacaoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaDocumentosPrestacaoInicio: [],
    buscaDocumentosPrestacaoSucesso: ['documentosPrestacao'],
    buscaDocumentosPrestacaoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaDocumentosPrestacao = filtro => {
    return dispatch => {
        dispatch(Creators.buscaDocumentosPrestacaoInicio())
        let serv = new DetalhesPrestacaoService()
        return serv
            .consultarDocumentosPrestacao(filtro)
            .then(response => dispatch(Creators.buscaDocumentosPrestacaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaDocumentosPrestacaoErro(error)))
    }
}

const buscaDocumentosPrestacaoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaDocumentosPrestacaoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaDocumentosPrestacaoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.documentosPrestacao, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_DOCUMENTOS_PRESTACAO_INICIO]: buscaDocumentosPrestacaoInicio,
    [Types.BUSCA_DOCUMENTOS_PRESTACAO_ERRO]: buscaDocumentosPrestacaoErro,
    [Types.BUSCA_DOCUMENTOS_PRESTACAO_SUCESSO]: buscaDocumentosPrestacaoSucesso,
})
